
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pam/secrets-management",
      function () {
        return require("private-next-pages/pam/secrets-management.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pam/secrets-management"])
      });
    }
  